import { StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
    cardStyle: {
        marginHorizontal: 16,
        marginTop: 32,
        marginBottom: 0,
        padding: 0,
    },
    cardContentContainer: {
        paddingVertical: 0,
        borderWidth: 0,
    },
    cardContainerWithTitle: {
        paddingVertical: 0,
        borderWidth: 2,
        borderColor: Colors.ocean
    }
})
